import {createContext} from 'react';

const PeopleContext = createContext(null);

export default PeopleContext;
